import React from 'react'
import { Row, Col, UncontrolledAlert, Modal, ModalHeader, ModalFooter, Button, Spinner } from 'reactstrap'
import PhoneInput from 'react-phone-number-input/input'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import { processError } from '../../lib/lib'
import getSystemFrontendSettings from '../../lib/systemFrontendSettings'
const cookies = new Cookies()

class Login extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            firstName: '',
            secondName: '',
            nickName: '',
            mail: '',
            phoneNumber: '',
            pwd: '',
            confirmPwd: '',
            orgName: '',
            rightsForm: 'individual',
            showError: false,
            errorMessage: '',
            profilePatronymic: '',
            userPid: '',
            modal: false,
            contryCode: cookies.get('countryCode') || 'RU',
            ref: '',
            field: '',
            registering: false,
            registerDocs: [],
            // eslint-disable-next-line no-undef
            template: process.env.REACT_APP_TEMPLATE,
        }
        this.firstNameChange = this.firstNameChange.bind(this)
        this.secondNameChange = this.secondNameChange.bind(this)
        this.nickNameChange = this.nickNameChange.bind(this)
        this.mailChange = this.mailChange.bind(this)
        this.phoneNumberChange = this.phoneNumberChange.bind(this)
        this.pwdChange = this.pwdChange.bind(this)
        this.confirmPwdChange = this.confirmPwdChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.showHidePwd = this.showHidePwd.bind(this)
        this.switchForm = this.switchForm.bind(this)
        this.orgNameChange = this.orgNameChange.bind(this)
    }

    orgNameChange(event) {
        this.setState({ orgName: event.target.value })
    }

    confirmPwdChange(event) {
        this.setState({ confirmPwd: event.target.value })
    }

    mailChange(event) {
        this.setState({ mail: event.target.value })
    }

    phoneNumberChange(value) {
        this.setState({ phoneNumber: value })
    }

    nickNameChange(event) {
        this.setState({ nickName: event.target.value })
    }

    firstNameChange(event) {
        this.setState({ firstName: event.target.value })
    }

    secondNameChange(event) {
        this.setState({ secondName: event.target.value })
    }

    pwdChange(event) {
        this.setState({ pwd: event.target.value })
    }

    showHidePwd(event) {
        event.preventDefault()
        const input = document.getElementById('user_pass')
        const type = document.getElementById('user_pass').attributes.type.value
        const eye = document.getElementById('show_hide_password')
        if (type === 'password') {
            input.setAttribute('type', 'text')
            eye.classList.remove('fa-eye-slash')
            eye.classList.add('fa-eye')
        } else {
            input.setAttribute('type', 'password')
            eye.classList.remove('fa-eye')
            eye.classList.add('fa-eye-slash')
        }
    }

    switchForm(event) {
        this.setState({ rightsForm: event.target.value })
        if (this.state.rightsForm === 'individual') {
            document.getElementById('user_orgName').setAttribute('required', 'false')
            document.getElementById('user_firstName').setAttribute('required', 'true')
            document.getElementById('user_secondName').setAttribute('required', 'true')
            document.getElementById('entityInputs').classList.add('d-none')
            document.getElementById('individualInputs').classList.remove('d-none')
        } else {
            document.getElementById('user_orgName').setAttribute('required', 'true')
            document.getElementById('user_firstName').setAttribute('required', 'false')
            document.getElementById('user_secondName').setAttribute('required', 'false')
            document.getElementById('individualInputs').classList.add('d-none')
            document.getElementById('entityInputs').classList.remove('d-none')
        }
    }

    async handleSubmit(event) {
        this.setState({ registering: true })
        try {
            event.preventDefault()
            if (this.state.pwd !== this.state.confirmPwd) {
                this.setState({ showError: true, errorMessage: 'Wrong password confirm', registering: false })
                return
            } else {
                const reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}$/
                const test = reg.test(this.state.pwd)
                // if (this.state.pwd.includes('*')) {
                //     this.setState({ showError: true, registering: false, errorMessage: "Password mustn't contain star keys (*)" })
                //     return
                // }
                if (!test) {
                    this.setState({ showError: true, registering: false, errorMessage: 'Password must contain minimum eight characters, at least one letter and one number' })
                    return
                }
            }
            const params = {
                "userLogin": this.state.nickName,
                "userEmail": this.state.mail,
                "userMobile": this.state.phoneNumber,
                "userPassword": this.state.pwd,
                "userFirstName": this.state.firstName,
                "userLastName": this.state.secondName,
                "userLegalName": this.state.orgName,
                "rightsForm": this.state.rightsForm,
                "profilePatronymic": this.state.profilePatronymic,
                "userPid": this.state.userPid,
                "userRef": this.state.ref,
                // "userRef": this.state.ref || 5107700951298510,
            }
            const registered = await api.register(params)
            if (registered.status === 'ok') {
                this.setState({ modal: true, registering: false })
            } else {
                const [field, message] = Object.entries(registered.errorData)[0]
                this.setState({
                    showError: true,
                    errorMessage: message,
                    field,
                    registering: false,
                })
                // switch (field) {
                //     case 'extraFields.userLogin':
                //         this.setState({
                //             showError: true,
                //             errorMessage: 'Invalid login value',
                //             nickName: '',
                //         })
                //         break
                //     case 'userEmail':
                //         this.setState({
                //             showError: true,
                //             errorMessage: `User with email ${this.state.mail} already exists`,
                //             mail: '',
                //         })
                //         break
                //     case 'userMobile':
                //         this.setState({
                //             showError: true,
                //             errorMessage: `User with phone number ${this.state.phoneNumber} already exists`,
                //             phoneNumber: '',
                //         })
                //         break
                //     case 'extraFields.userPassword':
                //         this.setState({
                //             showError: true,
                //             errorMessage: 'Password must contain upper and lower chars and numbers',
                //             pwd: '',
                //             confirmPwd: '',
                //         })
                //         break
                //     default:
                //         break
                // }
            }
        } catch (e) {
            this.setState({ showError: true, errorMessage: e.response ? e.response.data : 'Invalid api url', registering: false })
        }
    }

    componentWillMount() {
        const queryParams = new URLSearchParams(window.location.search)
        const ref = queryParams.get('ref')
        const lang = this.props.i18n.language
        
        getSystemFrontendSettings({ lang, force: true })
            .then((result) => {
                if (result) this.setState({ registerDocs: result.registerDocs })
            })
            .catch((e) => processError(e, this.props.history))

        cookies.set('ref', ref, { path: '/' })
        this.setState({ ref })
    }

    render() {
        const { t } = this.props
        return (
            <div className="position-relative">
                <Modal isOpen={this.state.modal} toggle={() => {
                    this.setState({ modal: false })
                    this.props.history.push('/login')
                }} className="mt-5">
                    <ModalHeader>{t('register-successfully-registered')}</ModalHeader>
                    <ModalFooter>
                        <Button className="custom-card-btn primary m-0 px-4 py-2" onClick={() => this.props.history.push('/login')}>Login</Button>
                    </ModalFooter>
                </Modal>
                <UncontrolledAlert
                    isOpen={this.state.showError}
                    toggle={() => this.setState({ showError: false })}
                    className="login-error"
                    color="danger"
                >{this.state.errorMessage}</UncontrolledAlert>
                <Row className="login-row w-100 m-0">
                    <Col xl={6} lg={12} className="login-bg">
                        <div className="main-logo"></div>
                        {/* <img src={logo} alt=""></img> */}
                    </Col>
                    <Col xl={6} lg={12} className="login-form px-0">
                        <div id="login" className="login loginpage col-md-8 offset-md-2">
                            <div className="login-welcome lg-font-size">{t('login-welcome1')} {t(`login-welcome-${this.state.template}`)}</div>
                            <div className="login-please md-font-size">{t('register-please')}</div>
                            <form
                                name="loginform"
                                id="loginform"
                                action="#!"
                                method="post"
                                onSubmit={this.handleSubmit}
                            >
                                <div className="login-radio-wrapper">
                                    <div className="login-form-check form-check-inline custom-radio">
                                        <input
                                            className="login-form-check-input custom-control-input"
                                            type="radio"
                                            name="rightsForm"
                                            id="individual"
                                            value="individual"
                                            onClick={this.switchForm}
                                            checked={this.state.rightsForm === 'individual' ? true : false}
                                        />
                                        <label className="login-form-check-label custom-control-label sm-font-size" htmlFor="individual">
                                            {t('register-individual')}
                                        </label>
                                    </div>
                                    <div className="login-form-check form-check-inline pl-20px custom-radio">
                                        <input
                                            className="login-form-check-input custom-control-input"
                                            type="radio"
                                            name="rightsForm"
                                            id="entity"
                                            value="entity"
                                            onClick={this.switchForm}
                                            checked={this.state.rightsForm === 'entity' ? true : false}
                                        />
                                        <label className="login-form-check-label custom-control-label sm-font-size" htmlFor="entity">
                                            {t('register-entity')}
                                        </label>
                                    </div>
                                </div>
                                <Row id="individualInputs" className={`${this.state.rightsForm === 'individual' ? '' : 'd-none'}`}>
                                    <Col xs={12} sm={6}>
                                        <div>
                                            <label htmlFor="user_firstName">
                                                <span className="login-label sm-font-size">{t('register-name')}</span>
                                                <input
                                                    type={this.state.rightsForm === 'individual' ? 'text' : 'hidden'}
                                                    name="firstName"
                                                    id="user_firstName"
                                                    className="input login-input md-font-size"
                                                    value={this.state.firstName}
                                                    onChange={this.firstNameChange}
                                                    size="20"
                                                    placeholder={t('register-inputName')}
                                                    required={this.state.rightsForm === 'individual' ? true : false}
                                                />
                                            </label>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={6}>
                                        <div>
                                            <label htmlFor="user_secondName">
                                                <span className="login-label sm-font-size">
                                                    {t('register-secondName')}
                                                </span>
                                                <input
                                                    type={this.state.rightsForm === 'individual' ? 'text' : 'hidden'}
                                                    name="secondName"
                                                    id="user_secondName"
                                                    className="input login-input md-font-size"
                                                    value={this.state.secondName}
                                                    onChange={this.secondNameChange}
                                                    size="20"
                                                    placeholder={t('register-inputSecondName')}
                                                    required={this.state.rightsForm === 'individual' ? true : false}
                                                />
                                            </label>
                                        </div>
                                    </Col>
                                </Row>
                                <Row id="entityInputs" className={`${this.state.rightsForm === 'individual' ? 'd-none' : ''}`}>
                                    <Col xs={12}>
                                        <div>
                                            <label htmlFor="user_orgName">
                                                <span className="login-label sm-font-size">
                                                    {t('register-orgName')}
                                                </span>
                                                <input
                                                    type={this.state.rightsForm === 'individual' ? 'hidden' : 'text'}
                                                    name="orgName"
                                                    id="user_orgName"
                                                    className="input login-input md-font-size"
                                                    value={this.state.orgName}
                                                    onChange={this.orgNameChange}
                                                    size="20"
                                                    placeholder={t('register-inputOrgName')}
                                                    required={this.state.rightsForm === 'individual' ? false : true}
                                                />
                                            </label>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <div>
                                            <label htmlFor="user_nickName">
                                                <span className="login-label sm-font-size">
                                                    {t('register-nickname')}
                                                </span>
                                                <input
                                                    type="text"
                                                    name="nickName"
                                                    id="user_nickName"
                                                    className="input login-input md-font-size"
                                                    value={this.state.nickName}
                                                    onChange={this.nickNameChange}
                                                    size="20"
                                                    placeholder={t('register-inputNickname')}
                                                    required
                                                />
                                            </label>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={6}>
                                        <div>
                                            <label htmlFor="user_mail">
                                                <span className="login-label sm-font-size">
                                                    {t('register-mail')}
                                                </span>
                                                <input
                                                    type="email"
                                                    name="mail"
                                                    id="user_mail"
                                                    className="input login-input md-font-size"
                                                    value={this.state.mail}
                                                    onChange={this.mailChange}
                                                    size="20"
                                                    placeholder={t('register-inputMail')}
                                                    required
                                                />
                                            </label>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={6}>
                                        <div>
                                            <label htmlFor="user_phoneNumber">
                                                <span className="login-label sm-font-size">
                                                    {t('register-phoneNumber')}
                                                </span>
                                                <PhoneInput id="user_phoneNumber" className="input login-input md-font-size"
                                                    // country={this.state.contryCode}
                                                    value={this.state.phoneNumber}
                                                    onChange={this.phoneNumberChange}
                                                    maxLength={20}
                                                    minLength={1}
                                                    required
                                                />
                                                {/* <input
                                                        type="tel"
                                                        name="phoneNumber"
                                                        id="user_phoneNumber"
                                                        className="input login-input"
                                                        value={this.state.phoneNumber}
                                                        onChange={this.phoneNumberChange}
                                                        size="20"
                                                        placeholder={t('register-inputPhoneNumber')}
                                                        required
                                                    /> */}
                                            </label>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={6}>
                                        <div>
                                            <label htmlFor="user_pwd">
                                                <span className="login-label sm-font-size">
                                                    {t('register-password')}
                                                </span>
                                                <input
                                                    type="password"
                                                    name="pwd"
                                                    id="user_pwd"
                                                    className="input login-input md-font-size"
                                                    value={this.state.pwd}
                                                    onChange={this.pwdChange}
                                                    size="20"
                                                    placeholder={t('register-inputPassword')}
                                                    required
                                                />
                                            </label>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={6}>
                                        <div>
                                            <label htmlFor="user_confirmPwd">
                                                <span className="login-label sm-font-size">
                                                    {t('register-passwordConfirm')}
                                                </span>
                                                <input
                                                    type="password"
                                                    name="confirmPwd"
                                                    id="user_confirmPwd"
                                                    className="input login-input md-font-size"
                                                    value={this.state.confirmPwd}
                                                    onChange={this.confirmPwdChange}
                                                    size="20"
                                                    placeholder={t('register-inputPasswordConfirm')}
                                                    required
                                                />
                                            </label>
                                        </div>
                                    </Col>
                                </Row>
                                <div className="form-check login-agreements">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="notifications"
                                    />
                                    <label
                                        className="form-check-label login-agreements-label md-font-size"
                                        htmlFor="notifications"
                                    >
                                        {t('register-notifications')}
                                    </label>
                                </div>
                                <div className="form-check login-agreements pb-40px">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="politics"
                                        required
                                    />
                                    <label
                                        className="form-check-label login-agreements-label md-font-size"
                                        htmlFor="politics"
                                    >
                                        {t('register-politics')}
                                    </label>
                                </div>
                                <div className="submit">
                                    {
                                        this.state.registering ?
                                            <Button variant="primary" disabled className="login-btn">
                                                <Spinner
                                                    as="span"
                                                    animation="grow"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            </Button>
                                            :
                                            <button
                                                type="submit"
                                                name="wp-submit"
                                                id="wp-submit"
                                                className="btn btn-primary btn-block md-font-size"
                                            >{t('register-register')}</button>
                                    }
                                </div>
                            </form>
                            <div id="nav" className="login-register-wrapper sm-font-size">
                                <div className='d-flex flex-column align-items-left'>
                                    <span className="login-notRegisered">
                                        {t('login-alreadyRegistered')}
                                    </span>
                                    <div className='d-flex flex-column'>
                                        {
                                            this.state.registerDocs.map((doc, index) => {
                                                const condition = doc && typeof(doc) === 'object' && doc.title && doc.url
                                                return (
                                                    <React.Fragment key={index}>
                                                        {
                                                            condition ?
                                                                <a style={{ color: "#7e7e7e" }} className="login-notRegisered" href={doc.url} rel='noopener  noreferrer' target="_blank">
                                                                    {doc.title}
                                                                </a> : ''
                                                        }
                                                    </React.Fragment>
                                                )
                                            })
                                        }
                                    </div>
                                    {/* <a style={{ color: "#7e7e7e" }} className="login-notRegisered" href={t('login-private-policy-link')} rel='noopener  noreferrer' target="_blank">
                                        {t('login-private-policy')}
                                    </a> */}
                                </div>
                                <a
                                    className="login-register"
                                    href="/login"
                                >
                                    {t('login-log-in')}
                                </a>
                            </div>
                            {/* <div className="login-social-media">
                                    <div className="login-authorize-text-wrapper">
                                        <hr className="login-authorize-text-line" />
                                        <div className="login-authorize">
                                            {t('register-authorize')}
                                        </div>
                                        <hr className="login-authorize-text-line" />
                                    </div>
                                    <div className="login-authorize-icons-wrapper">
                                        <a href="#!">
                                            <div className="login-authorize-icon-wrapper facebook-icon">
                                                <img
                                                    src={facebook}
                                                    alt=""
                                                    className="login-authorize-icon"
                                                ></img>
                                            </div>
                                        </a>
                                        <a href="#!">
                                            <div className="login-authorize-icon-wrapper tweeter-icon">
                                                <img
                                                    src={tweeter}
                                                    alt=""
                                                    className="login-authorize-icon"
                                                ></img>
                                            </div>
                                        </a>
                                        <a href="#!">
                                            <div className="login-authorize-icon-wrapper mail-icon">
                                                <img
                                                    src={mail}
                                                    alt=""
                                                    className="login-authorize-icon"
                                                ></img>
                                            </div>
                                        </a>
                                    </div>
                                </div> */}
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

Login.propTypes = {
    history: PropTypes.object,
    t: PropTypes.func,
    i18n: PropTypes.object,
}

export default withTranslation()(Login)



// WEBPACK FOOTER //
// ./src/views/Pages/Register.jsx